import { Component, Input, OnInit } from '@angular/core';
import {
    IMovementScheduleAccount,
    IMovementScheduleComponent,
    IMovementScheduleFli,
} from '@modeso/types__aumico-lib-annualreport-be';
import { ViewMode } from '@modeso/types__aumico-lib-core-be';
import {
    ComponentType,
    ComponentsOptionsDTO,
    IMovementScheduleEditableColumnHeaders,
} from '@modeso/types__aumico-lib-notes-be';
import { TemplateType } from '@modeso/types__aumico-lib-templates-be';
import Debug from 'debug';
import { cloneDeep } from 'lodash-es';

const debug = Debug('aumico:aumico-lib-notes-fe:PreviewComponent');

@Component({
    selector: 'aumico-notes-preview',
    templateUrl: 'preview.component.html',
    styleUrls: ['preview.component.scss'],
})
export class PreviewComponent implements OnInit {
    componentNames = ComponentType;
    previewComponentOptions: Map<string, Omit<ComponentsOptionsDTO, 'componentName'>>;
    @Input() componentList: string[];
    @Input() currentLanguage = 'de-ch';
    @Input() set componentOptions(value: Map<string, Omit<ComponentsOptionsDTO, 'componentName'>>) {
        if (value != null) {
            this.updatePreviewComponentOptions(value);
        }
    }
    @Input() viewMode: ViewMode = ViewMode.EDIT;

    mockedMovementScheduleData: IMovementScheduleComponent = {
        currentBalanceYearDate: '2021-08-19 19:13:32.230Z',
        previousBalanceYearDate: '2020-08-19 19:13:32.230Z',
        currentIncomeYearDate: '2021-08-20 19:13:32.230Z',
        previousIncomeYearDate: '2020-08-10 19:13:32.230Z',
        flis: [],
        headerOptions: undefined,
    };
    movementScheduleRows: IMovementScheduleAccount[] = [
        { id: 'hello', text: 'hello', closeValue: 5, column1: 5, column2: 5, column3: 5, column4: 5, openValue: 5 },
        { id: 'hi', text: 'hi', closeValue: 5, column1: 1, column2: 1, column3: 1, column4: 1, openValue: 1 },
        {
            id: 'welcome',
            text: 'welcome',
            closeValue: 15,
            column1: 21,
            column2: 31,
            column3: 14,
            column4: 15,
            openValue: 16,
        },
    ];

    mockedMovementScheduleFli: IMovementScheduleFli[] = [
        {
            id: 'cash',
            accounts: [this.movementScheduleRows[0]],
            caption: { 'de-ch': 'Cash and Cash', 'en-us': 'Cash and Cash' },
            position: 0,
            totalRow: undefined,
            headers: undefined,
            templateType: TemplateType.BALANCE,
        },
        {
            id: 'securities',
            accounts: [this.movementScheduleRows[1]],
            caption: { 'de-ch': 'Securities....', 'en-us': 'Securities....' },
            position: 1,
            totalRow: undefined,
            headers: undefined,
            templateType: TemplateType.BALANCE,
        },
        {
            id: 'raw',
            accounts: [this.movementScheduleRows[2]],
            caption: { 'de-ch': 'Raw....', 'en-us': 'Raw....' },
            position: 2,
            totalRow: undefined,
            headers: undefined,
            templateType: TemplateType.INCOME,
        },
    ];

    constructor() {}

    ngOnInit(): void {
        debug('ngOnInit');
    }

    private updateMovementScheduleMockedData(
        componentOptions: Map<string, Omit<ComponentsOptionsDTO, 'componentName'>>,
    ) {
        if (componentOptions.get('Movement Schedule') != null) {
            this.mockedMovementScheduleData.headerOptions = cloneDeep(
                componentOptions.get('Movement Schedule').componentOptions[0],
            ) as IMovementScheduleEditableColumnHeaders;
        }
    }

    updatePreviewComponentOptions(componentOptions: Map<string, Omit<ComponentsOptionsDTO, 'componentName'>>) {
        if (componentOptions != null) {
            this.previewComponentOptions = componentOptions;
            this.updateMovementScheduleMockedData(componentOptions);
        }
    }
}
